<template>
  <div class="card p-4">
    <div v-if="hasRight" class="card-body">
      <div v-if="modifyAction === false" class="form-profile">
        <div class="top">
          <label> Titre de la tâche </label>
          <input v-model="formAction.title" />
        </div>
        <div class="middle">
          <textarea
            v-model="formAction.desc"
            placeholder="Écrivez quelque chose... Les tâches que vous publierez seront visibles par tous vos collaborateurs participant au recrutement."
          >
          </textarea>
        </div>
        <div class="bottom">
          <div class="left">
            <div class="form-group">
              <p>Date d'échéance :</p>
              <h-f-fields v-model="formAction.end" input-type="date-time" class="w-100"></h-f-fields>
            </div>
            <div class="form-group">
              <p>Assigner à :</p>
              <h-f-fields
                v-model="formAction.assigned_user"
                :required="false"
                input-type="model-select"
                :model-select="userChoices"
                class="w-100"
              ></h-f-fields>
            </div>
          </div>
          <div class="right">
            <div v-if="loadedPost" class="btn-action-two" style="height: 30px" @click="createAction()">
              <p>Ajouter</p>
            </div>
            <div v-else class="d-flex justify-content-center align-items-center">
              <b-spinner variant="primary" style="width: 1.6rem; height: 1.6rem"></b-spinner>
            </div>
          </div>
        </div>
      </div>
      <div v-if="modifyAction === true" class="form-profile">
        <div class="top">
          <label> Titre de la tâche </label>
          <input v-model="formActionModify.title" />
        </div>
        <div class="middle">
          <textarea
            v-model="formActionModify.desc"
            placeholder="Écrivez quelque chose... Les tâches que vous publierez seront visibles par tous vos collaborateurs participant au recrutement."
          >
          </textarea>
        </div>
        <div class="bottom">
          <div class="left">
            <div class="form-group">
              <p>Date d'échéance :</p>
              <h-f-fields v-model="formActionModify.end" input-type="date-time" class="w-100"></h-f-fields>
            </div>
            <div class="form-group">
              <p>Assigner à :</p>
              <h-f-fields
                v-model="formActionModify.assigned_user"
                :required="false"
                input-type="model-select"
                :model-select="userChoices"
                class="w-100"
              ></h-f-fields>
            </div>
          </div>
          <div class="right">
            <div class="btn-action-dark" @click="cancelModifyAction">
              <p>Annuler</p>
            </div>
            <div class="btn-action-two" @click="editAction(formActionModify.id)">
              <p>Modifier</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loadedGet">
      <div class="mt-5">
        <div class="profile-section" :class="{ active: priorityTask }">
          <div class="header">
            <div class="top-title">
              <i class="bx bx-error-circle bx-sm"></i>
              TÂCHES PRIORITAIRES
              <span></span>
            </div>
            <i class="arrow mdi mdi-chevron-down" @click="turnPriorityTask"></i>
          </div>
          <div class="contentt">
            <div v-for="(action, index) in priorityTasks" :key="action.id" class="profile-component">
              <h5>
                {{ action.title }}
              </h5>
              <div class="desc">
                {{ action.desc }}
              </div>
              <div class="bottom">
                <div class="bottom-group">
                  <i class="mdi mdi-account"></i>
                  <p>Assigné à :</p>
                  <p>{{ action.assigned_user_first_name }} {{ action.assigned_user_last_name }}</p>
                  <p>par :</p>
                  <p>{{ action.user_first_name }} {{ action.user_last_name }}</p>
                </div>
                <div class="bottom-group">
                  <i class="mdi mdi-clock-outline"></i>
                  <p>Date d'échéance :</p>
                  <p>{{ action.end | formatDate }}</p>
                </div>
              </div>
              <div class="buttons-modify">
                <i class="bx bx-trash-alt" @click="deleteAction(action, index)"></i>
                <i class="bx bx-edit-alt" @click="modifyActionFunction(action)"></i>
                <i class="bx bx-error-circle" @click="unprioritizeAction(action, index)"><span></span></i>
              </div>
              <div class="button-action-non-active" @click="finishTask(action, index)">
                <i class="bx bx-check bx-sm"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5">
        <div class="profile-section" :class="{ active: currentTask }">
          <div class="header">
            <div class="top-title">
              <i class="bx bx-notepad bx-sm"></i>
              TÂCHES EN COURS
              <span></span>
            </div>
            <i class="arrow mdi mdi-chevron-down" @click="turnCurrentTask"></i>
          </div>
          <div class="contentt">
            <div v-for="(action, index) in ongoingTasks" :key="action.id" class="profile-component">
              <h5>
                {{ action.title }}
              </h5>
              <div class="desc">
                {{ action.desc }}
              </div>
              <div class="bottom">
                <div class="bottom-group">
                  <i class="mdi mdi-account"></i>
                  <p>Assigné à :</p>
                  <p>{{ action.assigned_user_first_name }} {{ action.assigned_user_last_name }}</p>
                  <p>par :</p>
                  <p>{{ action.user_first_name }} {{ action.user_last_name }}</p>
                </div>
                <div class="bottom-group">
                  <i class="mdi mdi-clock-outline"></i>
                  <p>Date d'échéance :</p>
                  <p>{{ action.end | formatDate }}</p>
                </div>
              </div>
              <div class="buttons-modify">
                <i class="bx bx-trash-alt" @click="deleteAction(action, index)"></i>
                <i class="bx bx-edit-alt" @click="modifyActionFunction(action)"></i>
                <i class="bx bx-error-circle" @click="prioritizeAction(action, index)"></i>
              </div>
              <div class="button-action-non-active" @click="finishTask(action, index)">
                <i class="bx bx-check bx-sm"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-5">
        <div class="profile-section" :class="{ active: endedTask }">
          <div class="header">
            <div class="top-title">
              <i class="mdi mdi-check-circle-outline bx-sm"></i>
              TÂCHES TERMINÉES
              <span></span>
            </div>
            <i class="arrow mdi mdi-chevron-down" @click="turnEndedTask"></i>
          </div>
          <div class="contentt">
            <div v-for="(action, index) in finishedTasks" :key="action.id" class="profile-component">
              <h5>
                {{ action.title }}
              </h5>
              <div class="desc">
                {{ action.desc }}
              </div>
              <div class="bottom">
                <div class="bottom-group">
                  <i class="mdi mdi-account"></i>
                  <p>Assigné à :</p>
                  <p>{{ action.assigned_user_first_name }} {{ action.assigned_user_last_name }}</p>
                  <p>par :</p>
                  <p>{{ action.user_first_name }} {{ action.user_last_name }}</p>
                </div>
                <div class="bottom-group">
                  <i class="mdi mdi-clock-outline"></i>
                  <p>Date d'échéance :</p>
                  <p>{{ action.end | formatDate }}</p>
                </div>
              </div>
              <div class="buttons-modify">
                <i class="bx bx-trash-alt" @click="deleteAction(action, index)"></i>
                <i class="bx bx-edit-alt" @click="modifyActionFunction(action)"></i>
              </div>
              <div class="button-action-active" @click="unfinishTask(action, index)">
                <i class="bx bx-check bx-sm"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="d-flex justify-content-center align-items-center mt-5">
      <b-spinner variant="primary" style="width: 3rem; height: 3rem"></b-spinner>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Action, APIRequest, FunctionHelpers, User } from '@/node-sdk'

export default {
  name: 'task',

  filters: {
    formatDate(date) {
      return moment(date).format('LL')
    },
  },

  props: {
    baseUrl: {
      type: String,
      required: true,
    },
    taskRoute: {
      type: String,
      required: true,
    },
    entity: {
      type: String,
      required: true,
    },
    entityId: {
      type: String,
      required: true,
    },
    hasRight: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      actions: [],
      loadedGet: false,
      loadedPost: true,
      priorityTasks: [],
      ongoingTasks: [],
      finishedTasks: [],
      userChoices: [],
      formAction: {
        title: null,
        desc: null,
        start: null,
        end: null,
        finished: false,
        priority: false,
        hover: false,
      },
      formActionInitial: {
        title: null,
        desc: null,
        start: null,
        end: null,
        finished: false,
        priority: false,
        hover: false,
      },
      formActionModify: {
        title: null,
        desc: null,
        start: null,
        end: null,
        finished: false,
        priority: false,
        hover: false,
      },
      priorityTask: true,
      currentTask: true,
      endedTask: true,
      modifyAction: false,
    }
  },

  async mounted() {
    await this.getUsers()
    await this.getActions()
  },
  methods: {
    async getUsers() {
      this.users = await User.get_users()
      this.formatUsersChoices()
    },

    async getActions() {
      this.loadedGet = false
      ;[this.actions] = await APIRequest.get_with_request(
        this.baseUrl,
        this.taskRoute,
        `?${this.entity}=${this.entityId}`,
      )
      this.formatActions()
      this.loadedGet = true
    },

    formatUsersChoices() {
      for (let i = 0; i < this.users.length; i++) {
        const userChoice = {
          text: `${this.users[i].first_name} ${this.users[i].last_name}`,
          value: this.users[i].uuid,
        }
        this.userChoices.push(userChoice)
      }
    },

    async getUser() {
      const userObject = localStorage.getItem('user_object')
      return JSON.parse(userObject).uuid
    },

    formatActions() {
      for (let i = 0; i < this.actions.length; i++) {
        this.actions[i].hover = false
        for (let j = 0; j < this.users.length; j++) {
          if (this.actions[i].user === this.users[j].uuid) {
            this.actions[i].user_first_name = this.users[j].first_name
            this.actions[i].user_last_name = this.users[j].last_name
          }
          if (this.actions[i].assigned_user === this.users[j].uuid) {
            this.actions[i].assigned_user_first_name = this.users[j].first_name
            this.actions[i].assigned_user_last_name = this.users[j].last_name
          }
        }
        if (this.actions[i].priority === true && this.actions[i].finished === false) {
          this.priorityTasks.push(this.actions[i])
        } else if (this.actions[i].priority === false && this.actions[i].finished === false) {
          this.ongoingTasks.push(this.actions[i])
        } else if (this.actions[i].finished === true) {
          this.finishedTasks.push(this.actions[i])
        }
      }
    },

    async createAction() {
      this.loadedPost = false
      this.formAction[this.entity] = this.entityId
      this.formAction.start = this.formAction.end
      const action = await APIRequest.create(this.baseUrl, this.taskRoute, this.formAction)
      for (let j = 0; j < this.users.length; j++) {
        if (action.user === this.users[j].uuid) {
          action.user_first_name = this.users[j].first_name
          action.user_last_name = this.users[j].last_name
        }
        if (action.assigned_user === this.users[j].uuid) {
          action.assigned_user_first_name = this.users[j].first_name
          action.assigned_user_last_name = this.users[j].last_name
        }
      }
      this.ongoingTasks.push(action)
      this.formAction = Action.get_form_action()
      this.$toast.open(FunctionHelpers.getMailSuccessOptions("à la personnes associés à l'activité"))
      this.loadedPost = true
    },

    async deleteAction(action, index) {
      await APIRequest.delete(this.baseUrl, this.taskRoute, action.id)
      if (action.priority === true && action.finished === false) {
        this.$delete(this.priorityTasks, index)
      } else if (action.priority === false && action.finished === false) {
        this.$delete(this.ongoingTasks, index)
      } else if (action.finished === true) {
        this.$delete(this.finishedTasks, index)
      }
    },

    async editAction(id) {
      await APIRequest.edit(this.baseUrl, this.taskRoute, id, this.formActionModify)
      this.formActionModify = Action.get_form_action()
      this.modifyAction = false
      this.$toast.open(FunctionHelpers.getMailSuccessOptions('à la personnes associée à la tâche'))
    },

    turnPriorityTask() {
      this.priorityTask = !this.priorityTask
    },

    turnCurrentTask() {
      this.currentTask = !this.currentTask
    },

    turnEndedTask() {
      this.endedTask = !this.endedTask
    },

    modifyActionFunction(action) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      this.formActionModify = action
      this.modifyAction = true
    },

    async prioritizeAction(action, index) {
      this.formActionModify = action
      this.formActionModify.priority = true
      this.priorityTasks.push(this.formActionModify)
      this.$delete(this.ongoingTasks, index)
      await this.editAction(this.formActionModify.id)
    },

    async unprioritizeAction(action, index) {
      this.formActionModify = action
      this.formActionModify.priority = false
      this.ongoingTasks.push(this.formActionModify)
      this.$delete(this.priorityTasks, index)
      await this.editAction(this.formActionModify.id)
    },

    async finishTask(action, index) {
      this.formActionModify = action
      this.formActionModify.finished = true
      this.finishedTasks.push(this.formActionModify)
      if (this.finishedTasks.priority) {
        this.$delete(this.priorityTasks, index)
      } else {
        this.$delete(this.ongoingTasks, index)
      }
      await this.editAction(this.formActionModify.id)
    },

    async unfinishTask(action, index) {
      this.formActionModify = action
      this.formActionModify.finished = false
      if (this.finishedTasks.priority) {
        this.priorityTasks.push(this.formActionModify)
      } else {
        this.ongoingTasks.push(this.formActionModify)
      }
      this.$delete(this.finishedTasks, index)
      await this.editAction(this.formActionModify.id)
    },

    cancelModifyAction() {
      this.modifyAction = false
    },
  },
}
</script>

<style scoped></style>
